import React, { forwardRef, useState } from 'react';
import DatePickerReact, { ReactDatePickerProps } from 'react-datepicker';
import { CalendarBlank } from 'phosphor-react';
import { ptBR } from 'date-fns/locale';

import 'react-datepicker/dist/react-datepicker.css';

import { DatePickerContainer, DatePickerStyle } from './styles';

type ButtonProps = React.HTMLProps<HTMLButtonElement>;
export type DatePickerMonthProps = ReactDatePickerProps;

const DatePickerCustomInput = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ value, onClick }) => {
    return (
      <DatePickerContainer
        className="datepicker-custom-input"
        onClick={onClick}
        type="button"
      >
        <span className={`${value === '' && '$gray700'}`}>
          {value === '' ? 'MMMM/yyyy' : value}
        </span>
        <div className="calendar">
          <CalendarBlank />
        </div>
      </DatePickerContainer>
    );
  },
);

export const DatePickerMonth: React.FC<DatePickerMonthProps> = ({
  ...props
}) => {
  const [selectedDate, useSelectedDate] = useState<Date | null>(new Date());
  return (
    <DatePickerStyle>
      <DatePickerReact
        selected={selectedDate}
        dateFormat="MMMM/yyyy"
        locale={ptBR}
        showMonthYearPicker
        customInput={<DatePickerCustomInput />}
        {...props}
        maxDate={new Date()}
        onChange={(date) => useSelectedDate(date)}
      />
    </DatePickerStyle>
  );
};
